import Vue from "vue";
import Vuex from "vuex";
import router from '@/router/index.js'
// import User from "./modules/user";
// import Login from "./modules/login";
// import Order from "./modules/order";
import Chinese from "@/utils/Chinese.js";
import English from "@/utils/English.js";
import Russian from "@/utils/Russian.js";
// import { instance, couponInstance } from "@/utils/http";
// import { storage } from "@/utils/util";
Vue.use(Vuex);

var userAgentInfo = navigator.userAgent.toLowerCase();
var userAgent = navigator.userAgent;
var pcFlag = true;

if (userAgentInfo.indexOf('miniprogram') > -1 || userAgentInfo.indexOf('mini_program') > -1 || window.__wxjs_environment === 'miniprogram') {
  pcFlag = false;
} else if (userAgentInfo.indexOf('micromessenger') > -1) {
  if (userAgent.indexOf('Windows') > -1 || userAgent.indexOf('Win32') > -1) {
    pcFlag = true;
  } else {
    pcFlag = false;
  }
} else {
var Agents = ["Android", "iPhone",
      "SymbianOS", "Windows Phone",
      "iPad", "iPod", "harmonyos", "openharmony"];
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > -1) {
      pcFlag = false;
      break;
    }
  }
}
var language = (navigator.language || navigator.browserLanguage).toLowerCase()

export default new Vuex.Store({
  state: {
    router: [],
    // eslint-disable-next-line no-undef
    lanuage: language.indexOf('zh') > -1 ? 'Chinese' : language.indexOf('ru') > -1 ? 'Russian' : 'English',
    // eslint-disable-next-line no-undef
    content: language.indexOf('zh') > -1 ? Chinese : language.indexOf('ru') > -1 ? Russian : English,
    isPc: pcFlag,
    userInfo: sessionStorage.getItem('wx_userInfo') ? JSON.parse(sessionStorage.getItem('wx_userInfo')) : null
  },
  getters: {
  },
  mutations: {
    setRouter(state, data) {
      let index = state.router.findIndex((item) => item === data);
      if (index >= 0) {
        state.router.splice(index, 1);
      }
      state.router.push(data);
    },
    clearRouter(state, route) {
      state.router.splice(
        state.router.findIndex((item) => item === route),
        1
      );
    },
    // 选择语言
    changeLanguage(state, type){
      state.lanuage = type
      if(type=='English'){
        state.content = English
      }else if(type=='Chinese'){
        state.content = Chinese
      }else if(type=='Russian'){
        state.content = Russian
      }
    },
    // 微信登录后保存用户信息，用于展示头像等
    saveUserInfo(state, userInfo) {
      state.userInfo = userInfo
      sessionStorage.setItem('wx_userInfo', JSON.stringify(userInfo))
    },
  },
  actions: {
    // 登出
    logout(state) {
      sessionStorage.removeItem('wx_userInfo')
      localStorage.removeItem('loginItem')
      localStorage.removeItem('x_token')
      router.replace({
        path: '/entry',
        query: {
          openId: router.history.current.query.openId,
          conventionId: router.history.current.query.conventionId,
          room: router.history.current.query.room,
          live_meeting_id: router.history.current.query.live_meeting_id,
          siteId: router.history.current.query.siteId,
          video_id: router.history.current.query.video_id,
        }
      })
    }
  }
});
